import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'
import Filter from 'containers/Reports/AssetAssociatedInventoryReport/Filter'

export default createListViewComponent({
  entityName: entityNames.assetAssociatedInventoryReport,
  filterTemplateType: 'AssetAssociatedInventoryReport',
  allowCreate: (self) => false,
  allowSelection: (self) => false,
})(Filter)
